module.exports = __webpack_public_path__ + "img/2_of_Hearts.svg.010ac535.png";